"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var hoist_non_react_methods_1 = require("hoist-non-react-methods");
var isStatelessComponent = function (Component) {
    return !(Component.prototype && Component.prototype.render);
};
exports.createHOC = function (Component) {
    var WixComponent = /** @class */ (function (_super) {
        tslib_1.__extends(WixComponent, _super);
        function WixComponent() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.wrappedComponentRef = null;
            return _this;
        }
        WixComponent.prototype.componentDidMount = function () {
            var _a = this.props, dataHook = _a.dataHook, dataClass = _a.dataClass;
            if (dataHook || dataClass) {
                var domNode = ReactDOM.findDOMNode(this);
                if (domNode && domNode instanceof Element) {
                    dataHook && domNode.setAttribute('data-hook', dataHook);
                    dataClass && domNode.setAttribute('data-class', dataClass);
                }
            }
        };
        WixComponent.prototype.componentDidUpdate = function (prevProps) {
            var dataHook = this.props.dataHook;
            if (prevProps.dataHook !== dataHook) {
                var domNode = ReactDOM.findDOMNode(this);
                if (domNode && domNode instanceof Element) {
                    domNode.setAttribute('data-hook', dataHook);
                }
            }
        };
        WixComponent.prototype.render = function () {
            var _this = this;
            // Can't pass refs to stateless components (and also there's nothing to hoist)
            return isStatelessComponent(Component) ? (React.createElement(Component, tslib_1.__assign({}, this.props))) : (React.createElement(Component, tslib_1.__assign({ ref: function (ref) { return (_this.wrappedComponentRef = ref); } }, this.props)));
        };
        WixComponent.displayName = Component.displayName || Component.name || 'WixComponent';
        return WixComponent;
    }(React.PureComponent));
    return isStatelessComponent(Component)
        ? WixComponent
        : hoist_non_react_methods_1.default(WixComponent, Component, {
            delegateTo: function (c) { return c.wrappedComponentRef; },
            hoistStatics: true,
        });
};
//# sourceMappingURL=index.js.map